import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemName,
  setItemNameLat,
} from '@/modules/Dictionary/__form/item';

export default class DictionaryTariffForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'tariff';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)();
    setItemNameLat.bind(this)();
    setItemCode.bind(this)();
  }
}
